module.exports = __webpack_public_path__ + "img/NUMBER_ALGEBRA.b0e3f70b.png";